import React from 'react';
import {
    FloatingActionMenu,
    Checkbox,
    Text,
    Container,
    Box,
} from '@landr/maestro';
import { Trans, t } from '@lingui/macro';
import { useMatch } from 'react-router-dom';
import AddSampleToCollectionButton from 'components/CommonUi/AddSampleToCollectionButton';
import { useSelectedSamplesContext } from 'contexts/SelectedSamplesContext/SelectedSamplesContext';
import useGetCurrentBreakpoint from 'hooks/useGetCurrentBreakpoint/useGetCurrentBreakpoint';
import { useCreatorContext } from 'controllers/business/Creator/Creator.controller';
import { getDetailsViewSizes } from 'components/DetailsView/helpers/getDetailsViewSizes';
import { useExecutionEnvironmentContext } from 'contexts/ExecutionEnvironmentContext/ExecutionEnvironmentContext';
import { DownloadButton } from '../CommonUi/DownloadButton';
import { RoutePaths } from '../../types/enums';
import DeleteCollectionSampleButton from '../DeleteCollectionSampleButton';

export const FloatingActionsMenu: React.FC = () => {
    const { isVisible: isCreatorVisible } = useCreatorContext();
    const { isDAWPlugin } = useExecutionEnvironmentContext();

    const { samples: selectedSamples, clearSamplesSelection } =
        useSelectedSamplesContext();

    const currentBreakpoint = useGetCurrentBreakpoint();
    const { isSm } = getDetailsViewSizes({
        currentBreakpoint,
    });

    const isCollectionDetailsPage = useMatch(
        `/${RoutePaths.UserCollections}/:id`,
    );

    const routesToHideMenu = [`/${RoutePaths.UserCollections}`];

    const isFloatingActionsMenuVisible = !routesToHideMenu.some(
        (route) => route === location.pathname,
    );

    if (!isFloatingActionsMenuVisible || isSm || !selectedSamples.length) {
        return null;
    }

    return (
        <Container>
            <Box>
                <Box
                    data-component="FloatingActionMenu"
                    position="fixed"
                    bottom={isCreatorVisible ? '92px' : 'sm'}
                    backgroundColor="transparent"
                    width="auto"
                    maxWidth="100%"
                    transition="bottom 300ms ease-in-out"
                    transform="translateX(-12px)"
                >
                    <FloatingActionMenu>
                        <Checkbox
                            label={t`Unselect all sounds`}
                            hideLabel
                            isChecked
                            onChange={clearSamplesSelection}
                            data-testid="toast-checkbox"
                        />
                        <Text display="block" width="100%" marginX="lg">
                            {`${selectedSamples.length}`}
                            &nbsp;<Trans>selected</Trans>
                        </Text>
                        <Box marginRight="2xs">
                            <AddSampleToCollectionButton
                                samples={selectedSamples}
                                source={{ interaction: 'Multi-select' }}
                                variant="subtle"
                                isRounded
                                size="sm"
                                popoverPlacement="bottom-start"
                            />
                        </Box>
                        {isCollectionDetailsPage && (
                            <Box marginRight="2xs">
                                <DeleteCollectionSampleButton
                                    samples={selectedSamples}
                                    variant="subtle"
                                    aria-label={t`Remove from collection`}
                                    label={t`Remove from collection`}
                                    isRounded
                                    size="sm"
                                />
                            </Box>
                        )}
                        {!isDAWPlugin && (
                            <Box marginRight="2xs">
                                <DownloadButton
                                    item={selectedSamples.map(
                                        (sample) => sample.guid,
                                    )}
                                    variant="subtle"
                                    isRounded
                                    size="sm"
                                />
                            </Box>
                        )}
                    </FloatingActionMenu>
                </Box>
            </Box>
        </Container>
    );
};

export default FloatingActionsMenu;
